import { action as apiAction } from 'api/Api'
import {
  add
} from '../redux/cardBlockers'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  blockerId: number
  reason?: string
  userId?: number
}

const requestAddCardBlocker = ({
  cardId,
  blockerId,
  reason,
  userId,
}: Payload) => async (dispatch, getState) => {
  const optimisticAction = optimisticDispatch(dispatch, add({
    cardBlocker: {
      id: `temp-${new Date().getTime()}`,
      blockerId,
      cardId,
      reason,
      userId,
      creationDate: Date.now(),
      createdBy: `u:${getState().kanbo.currentUser.id}`,
      isBusy: true,
    },
  }))

  try {
    await apiAction('AddBlockerToCard', {
      cardId,
      blockerId,
      reason,
      userId,
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestAddCardBlocker
